var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainSvc1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3089 21.8865H47.2657C46.2602 9.73846 36.0827 0.19043 23.6748 0.19043C10.6003 0.19043 0 10.7916 0 23.8652C0 36.9389 10.5995 47.5392 23.6748 47.5392V44.3807H23.6651C12.3272 44.3807 3.1391 35.1934 3.1391 23.8555C3.1391 12.5177 12.3264 3.32953 23.6651 3.32953C34.3389 3.32953 43.1057 11.4742 44.0967 21.8865H42.1075C41.1287 21.8865 41.2804 23.2576 41.5515 23.5319L45.0045 28.101C45.3233 28.4222 45.8389 28.4214 46.1569 28.101L49.6115 23.5327C49.9601 23.1801 50.3967 21.8873 49.3089 21.8873V21.8865Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0347 24.9298C21.7504 23.1472 23.0213 21.409 23.0213 19.7377C23.0213 17.2862 20.8151 15.7045 17.6954 15.7045C15.4891 15.7045 13.3716 16.5736 11.4551 18.0221L12.8374 20.652C14.2407 19.4489 15.8458 18.6911 17.1821 18.6911C18.5185 18.6911 19.3222 19.2705 19.3222 20.2736C19.3222 21.0313 18.6306 22.1005 17.6284 23.1036L11.8561 29.0534V31.4823H23.5781V28.5184H16.4026L20.0347 24.9306V24.9298Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1118 21.6539H30.8807V25.1078H27.2485L31.9063 15.8599H28.563L23.5938 25.4862V27.9378H30.8807V31.4812H34.1118V27.9378H36.251V25.1078H34.1343L34.1118 21.6539Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainSvc1);
export default __webpack_public_path__ + "static/media/main_svc1.9f57e791fca4eb22a02dc4c39bc49103.svg";
export { ForwardRef as ReactComponent };